export default {
    //请求方式
    method: 'post',
    // 基础url前缀
    baseURL: 'https://api.zuidie.net',
    // 请求头信息
    headers: {},
    // 参数
    data: {},
    // 设置超时时间
    timeout: 10000,
    // 携带凭证
    withCredentials: false,
    // 返回数据类型
    responseType: 'json'
}


// WEBPACK FOOTER //
// ./src/http/config.js